module.exports = {
      id: "visibility-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#visibility",
      toString: function () {
        return this.url;
      }
    }